<div class="main-container" [ngClass]="{ large: !thumbnail, small: thumbnail }">
  <div class="avatar-container">
    <img *ngIf="shouldShowAvatar() && !darkened" [src]="getImageUrl()" alt="" />
    <img *ngIf="shouldShowAvatar() && darkened" [src]="getDarkened()" alt="" />
    <img *ngIf="shouldShowAvatar()" class="prefetched-darkened-image" [src]="getDarkened()" alt="" />
    <img *ngIf="!shouldShowAvatar() && !noDefaultAvatar && !selected" [src]="getDefaultImageUrl()" alt="" />
    <mat-icon *ngIf="selected" color="primary" class="md-40" data-testid="person-selected">check_circle</mat-icon>
    <div
      *ngIf="!shouldShowAvatar() && noDefaultAvatar"
      [ngClass]="{ 'avatar-large': !thumbnail, 'avatar-small': thumbnail }"
    ></div>
  </div>
</div>
